import React from 'react';
import Svg, { SvgProps, G, Path } from 'react-native-svg';

export const SvgDelivery = ({ strokePath, ...props }: SvgProps) => (
  <Svg viewBox="0 0 24 24" width={'100%'} height={'100%'} {...props}>
    <G fill="none" fillRule="evenodd">
      <Path d="M0 0h24v24H0z" />
      <Path
        fill={strokePath}
        d="M19,15c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S20.7,15,19,15z M19,19c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S19.6,19,19,19z"
      />
      <Path
        fill={strokePath}
        d="M21.4,12.5c-0.5-0.2-0.9-0.3-1.4-0.4V9c1.1-0.2,2-1.2,2-2.5C22,5.1,20.9,4,19.5,4H17c-0.6,0-1,0.4-1,1s0.4,1,1,1h2.5   C19.8,6,20,6.2,20,6.5S19.8,7,19.5,7H19c-0.6,0-1,0.4-1,1v4.1c-2.2,0.4-3.9,1.9-4.6,3.9H12v-6h1c0.6,0,1-0.4,1-1s-0.4-1-1-1H5   C4.4,8,4,8.4,4,9s0.4,1,1,1h1.7C3.9,11.4,2,14,2,17c0,0.6,0.4,1,1,1h0.1c0.2,1.7,1.7,3,3.4,3s3.2-1.3,3.4-3H11h2c0,0.6,0.4,1,1,1   s1-0.4,1-1c0-2.2,1.8-4,4-4c0.6,0,1.1,0.1,1.6,0.3c0.5,0.2,1.1,0,1.3-0.5C22.1,13.3,21.9,12.7,21.4,12.5z M6.5,19   c-0.7,0-1.2-0.4-1.4-1h2.8C7.7,18.6,7.2,19,6.5,19z M10,16H9H4.1c0.5-2.6,2.9-4.6,5.9-4.9V16z"
      />
    </G>
  </Svg>
);
